import { MutationHookOptions, useMutation } from '@apollo/client';

import createManagementTeamMutation from './createManagementTeam.graphql';

// teamType is always FLEET and is hardcoded in the .graphql mutation
export type CreateManagementTeamVariables = {
  teamKey: string;
  name: string;
  applicationName?: string | null;
  sources?: Array<{ sourceId: string; sourceType: string }> | null;
  ownerEmail: string;
  apiUser?: { username: string; password: string } | null;
  oemSegmentId?: string | null;
};

export type CreateManagementTeamResult = {
  createSentinelTeam?: {
    sentinelTeam: {
      id: string;
      name: string;
      teamKey: string;
      teamType: string;
      platformAccounts: Array<{ id: string; sourceId: string; name: string }>;
    };
  };
};

export default function useCreateManagementTeamMutation(
  options?: MutationHookOptions<
    CreateManagementTeamResult,
    CreateManagementTeamVariables
  >,
) {
  return useMutation<CreateManagementTeamResult, CreateManagementTeamVariables>(
    createManagementTeamMutation,
    {
      refetchQueries: ['SentinelTeams', 'ManagedSentinelTeams'],
      ...options,
    },
  );
}
